import { Directive, Host } from '@angular/core';
import { IonToggle } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { Profile } from '../../../../../frontend-shared/src/lib/models';
import { ToastService } from '../../services/commons/toast.service';
import { LoggedProfileStore } from './logged-profile.store';

@Directive({ selector: 'ion-toggle[cwtProfileNotificationToggle]' })
export class ProfileNotificationToggleDirective {

    private profile: Profile;

    constructor(
        @Host() private toggle: IonToggle,
        private loggedProfileStore: LoggedProfileStore,
        private toast: ToastService
    ) {
        this.loggedProfileStore.state$.subscribe(res => this.onProfileChange(res?.profile));
        this.toggle.ionChange.subscribe(($event) => this.onCheckedChange($event.detail.checked))
    }

    private onProfileChange(profile: Profile) {
        this.profile = profile;
        const checked = this.toggle.checked;
        if (checked !== profile?.user?.acceptNotif) {
            this.toggle.checked = profile?.user?.acceptNotif;
        }
    }

    public onCheckedChange($event: boolean) {
        if (this.profile?.user?.acceptNotif === $event) return;
        this.toggle.disabled = true;
        this.loggedProfileStore.updateProfile({ user: { acceptNotif: $event } }).pipe(
            finalize(() => {
                this.toggle.disabled = false;
            }),
        ).subscribe(() => {
            this.toast.success('notification.notification-setting-updated')
        });
    }
}